import GlobalVariable from '@/global/global-variable'

// 查询账户
const searchAccountsApi = GlobalVariable.BASE_PATH + "/rest/account/search";

// 查询账户 单个
const findAccountApi = GlobalVariable.BASE_PATH + "/rest/account/findByAccountId";

// 新增账户
const addAccountApi = GlobalVariable.BASE_PATH + "/rest/account/add";

// 分配角色、修改账户
const updateAccountApi = GlobalVariable.BASE_PATH + "/rest/account/update";

// 删除账户
const deleteAccountApi = GlobalVariable.BASE_PATH + "/rest/account/delete";

// 启用账户
const startUseAccountApi = GlobalVariable.BASE_PATH + "/rest/account/startUse";
// 禁用账户
const disableUseAccountApi = GlobalVariable.BASE_PATH + "/rest/account/disable";

// 修改密码
const updatePwdApi = GlobalVariable.BASE_PATH + "/rest/account/updatePwd";
// 重置密码
const resetPwdApi = GlobalVariable.BASE_PATH + "/rest/account/restPwd";

// 设置管理员账户 （只有总管理员账户角色）
const setAccountManagerApi = GlobalVariable.BASE_PATH + "/rest/account/setAccountManager";
// 更新mq账户信息 （暂时不用）
const updateMqUserApi = GlobalVariable.BASE_PATH + "/rest/account/updateMqUser";
// 查询所有管理员账户 （总管理员添加设备时使用）
const searchAccountManagerApi = GlobalVariable.BASE_PATH + "/rest/account/searchAccountManager";

const searchAccountSystemNameApi = GlobalVariable.BASE_PATH + "/rest/account/searchSystemName";
const saveSystemNameApi = GlobalVariable.BASE_PATH + "/rest/account/saveSystemName";

export default {
    // 查询账户 list
    searchAccountsApi,
    
    // 查询账户 单个
    findAccountApi,
    // 新增账户
    addAccountApi,
    // 分配角色、修改账户
    updateAccountApi,
    // 删除账户
    deleteAccountApi,
    // 启用账户
    startUseAccountApi,
    // 禁用账户
    disableUseAccountApi,
    
    // 修改密码
    updatePwdApi,
    // 重置密码
    resetPwdApi,
    
    // 设置管理员账户 （只有总管理员账户角色）
    setAccountManagerApi,
    // 更新mq账户信息 （暂时不用）
    updateMqUserApi,
    // 查询所有管理员账户 （总管理员添加设备时使用）
    searchAccountManagerApi,

    // 查询系统名
    searchAccountSystemNameApi,
    saveSystemNameApi,

}



// WEBPACK FOOTER //
// ./src/request/api-account.js